import React from 'react';
import PropTypes from 'prop-types';

import { Message } from 'semantic-ui-react';

import { useTranslation } from 'react-i18next';

export function MissingEventMessage({ config = {} }) {
    const { t } = useTranslation();
    return !config.event_id ? <Message color="red">{t('ticket.widget.queue_step.no_event_id')}</Message> : null;
}

MissingEventMessage.propTypes = {
    config: PropTypes.object
};
